define(function (require) {
    var ko = require("knockout");
    var $ = require("jquery");
    var snfService = require("@modules/tools/snf-search/snfService");
    require("@modules/tools/ko.async");
    require("@modules/tools/ko.extensions");
    var FacilityResultViewModel = require("@modules/tools/facilityResultViewModel");
    var urlParameters = require("@modules/tools/urlParameters");
    var geocoder = require("@modules/tools/geocoder");
    var querystring = require("querystring");
    var utility = require("@modules/tools/helpfulToolUtility");
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    var whitelistUrlService = require("@modules/tools/whitelistUrlService");

    // HospitalSearchViewModel ctor
    return function (gtmDataLayerPush) {
        var self = this;
        var focusedElement;
        var defaultParameters = {
            zipOrAddress: "",
            radius: "5",
            pageNumber: 1,
            year: window.scan.aepYears[window.scan.aepYears.length - 1],
            sort: "distance"
        };

        var initialLoad = true;

        var dataLayer = window.dataLayer || [];
        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        var pageSize = window.scan.resultPageSize > 0 ? window.scan.resultPageSize : 20;

        dataLayer.push({
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Snfs Search"
        });

        var tempResults = [];

        var urlParams = urlParameters.read();
        var returnUrl = getPropertyCaseInsensitive(urlParams, "return_url");

        self.isDrx = ko.observable(false);
        self.selectPcp = ko.observable(false);

        if (returnUrl) {
            whitelistUrlService
                .validateUrl(returnUrl)
                .done(function (data) {
                    self.isDrx(true);
                })
                .fail(function (jqXHR) {
                    console.log(jqXHR.responseJSON.Message);
                });
        }

        var path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));

        if (urlParams.year) {
            urlParams.year = parseInt(urlParams.year, 10); // make the year a number if set in url
        }
        if (urlParams.pageNumber) {
            urlParams.pageNumber = parseInt(urlParams.pageNumber, 10); // make the year a number if set in url
        }

        self.currentSearchParameters = ko.observable();

        // various flags/state properties
        // self.isSearching = ko.observable(true);  // duplicate
        self.isSearchStarted = ko.observable(false);
        self.pageSize = ko.observable(pageSize);
        self.pageNumber = ko.observable(urlParams.pageNumber || 1);
        self.fatalError = ko.observable(false);
        self.detailId = ko.observable();
        self.isLeavingForDetailPage = ko.observable(false);
        self.hasSearchRun = ko.observable(false);
        var isSystemResettingFilters = false;

        // The following is for the updated data label text that appears when printing the results
        // list as both hospital and snf share the FaciltyResult view.
        self.updatedLabelText = "Skilled Nursing Facility";

        // form field values
        self.year = ko.observable().extend({ defaultOnNull: defaultParameters.year });
        self.zipOrAddress = ko.observable().extend({ defaultOnNull: defaultParameters.zipOrAddress });
        self.name = ko.observable();
        self.radius = ko.observable();
        self.sort = ko.observable().extend({ defaultOnNull: defaultParameters.sort });

        var primaryFilters = {
            sort: self.sort,
            zipOrAddress: self.zipOrAddress,
            radius: self.radius,
            name: self.name,
            year: self.year
        };

        var secondaryFilters = {};

        // these are the options available from the select lists.
        self.yearOptions = ko.observableArray(window.scan.aepYears);
        self.radiusOptions = ko.observableArray(utility.mapFacets(window.scan.emptyRadiusOptions));
        self.nameOptions = ko.observableArray([]);

        // loading status
        self.loadingResults = ko.observable(false);
        self.displayRequiredFieldError = ko.observable(false);

        //we need this to populate the updated date in the footer for the PDF
        self.contextItemId = ko.observable(window.scan.contextItemId);
        self.totalResults = ko.observable(0);
        self.results = ko.observableArray();
        self.pageList = ko.observableArray([]);

        self.zipOrAddress.subscribe(function (value) {
            if (!value) {
                self.radiusOptions(utility.mapFacets(window.scan.emptyRadiusOptions));
                self.isSearchStarted(false);
            }
        });
        // for typeahead
        self.suggestions = ko.observableArray([]);

        var usedNonDefaultParams = utility.initializeFilters(self, urlParams, defaultParameters);

        // This needs to sit above the self.filters and self.filters.subscribe definitions
        // so that it can fire first. See note in FB38870.
        self.zipOrAddress.subscribe(function () {
            // This flag keeps loadFacets from running.
            var isZipChangingRadius = true;

            if (self.zipOrAddress()) {
                self.radius(5);
            } else {
                self.radius(null);
            }

            isZipChangingRadius = false;
        });

        // this is a computed that will change whenever the user actually changes any of the filters that appear on the page.
        self.filters = ko.computed(function () {
            focusedElement = document.activeElement;
            if (!self.year()) {
                self.isSearchStarted(false);
                utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            }

            if (!utility.filtersHaveNonDefaultValues(primaryFilters, defaultParameters)) {
                self.isSearchStarted(false);
                utility.resetFiltersToDefaults(secondaryFilters, defaultParameters);
            }

            return {
                year: self.year(),
                zipOrAddress: self.zipOrAddress(),
                name: self.name(),
                radius: self.radius(),
                sort: self.sort()
            };
        });

        self.filters.subscribe(function () {
            if (isSystemResettingFilters) {
                return false;
            }
            self.pageNumber(1);
            self.results([]);
            self.totalResults(0);
            self.displayRequiredFieldError(false);
            self.fatalError(false);
            self.currentSearchParameters(null);
            tempResults = [];
        });

        self.urlParameters = ko.computed(function () {
            var filters = self.filters();

            return {
                year: filters.year,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                radius: filters.radius,
                sort: filters.sort,
                pageNumber: self.pageNumber(),
                detailId: self.detailId(),
                path: path
            };
        });
        self.urlParameters.subscribe(function (params) {
            urlParameters.write(params, defaultParameters);
        });

        // this combines the currently selected values into a parameters object
        // for passing to our facets/results services.
        self.searchParameters = ko.computed(function () {
            var filters = self.filters();

            if (!initialLoad) {
                self.detailId("");
            }

            return {
                year: filters.year,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                radius: filters.radius,
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize(),
                sort: self.sort()
            };
        });

        self.hasMore = ko.computed(function () {
            if (!self.totalResults()) {
                return false;
            }
            if (self.pageSize() * self.pageNumber() >= self.totalResults()) {
                return false;
            }
            return true;
        });

        // this id will be used to keep track of the latest search that we performed.
        // we will throw out any search results that were not for the latest ID.
        // this helps address the scenario where the user is rapidly changing filters
        // and triggering multiple searches.
        // we only want to display results for the last set of search parameters.
        var lastSearchRequestId = 1;

        var executeSearch = function () {
            if (!self.isAnyRequiredFieldPopulated()) {
                self.isSearchStarted(false);
                return;
            }

            var id = ++lastSearchRequestId;

            self.loadingResults(true);
            self.fatalError(false);

            var parameters = self.searchParameters();

            gtmDataLayerPush(parameters, defaultParameters);

            snfService
                .getResults(parameters)
                .done(function (results) {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    console.log(">>>>>>>>>> executeSearch returned " + results.CurrentResults.length + " results @ " + new Date());

                    self.results([]); // clear out results from previous page
                    tempResults = tempResults.concat(results.CurrentResults);

                    for (var i in results.CurrentResults) {
                        if (results.CurrentResults.hasOwnProperty(i)) {
                            self.results.push(new FacilityResultViewModel(self, results.CurrentResults[i], results.latitude, results.longitude, parameters.year, parameters.radius));
                        }
                    }
                    self.currentSearchParameters(parameters);
                    self.radiusOptions(results.Facets.Radius);
                    self.nameOptions(results.Facets.Name);
                    self.totalResults(results.TotalResults);
                    self.loadingResults(false);
                    self.isSearchStarted(false);

                    utility.recalculatePageNumbers(self);
                    self.hasSearchRun(true);

                    if ($(focusedElement).attr("name")) {
                        setTimeout(function () {
                            $("#" + $(focusedElement).attr("id")).focus();
                        }, 100);
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }
                    self.fatalError(true);
                    self.loadingResults(false);
                });
        };

        self.searchParameters.subscribe(function (newValue) {
            if (isSystemResettingFilters) {
                return false;
            }
            // set isSearchStarted to show spinner
            self.isSearchStarted(true);
            tempResults = [];
            executeSearch();
        });

        // status indicators
        self.pages = ko.computed(function () {
            return Math.ceil(self.totalResults() / self.pageSize());
        });
        self.isAEP = ko.computed(function () {
            return self.yearOptions() && self.yearOptions().length > 1;
        });

        self.isAnyRequiredFieldPopulated = function () {
            return self.zipOrAddress() && (self.zipOrAddress().length >= 5 || (self.name() && self.name().length >= 3));
        };

        self.arePrimaryFiltersEnabled = ko.computed(function () {
            return !self.isAEP() || self.year();
        });

        self.areSecondaryFiltersEnabled = ko.computed(function () {
            return (!self.isAEP() || self.year()) && self.isAnyRequiredFieldPopulated();
        });

        // clear filter functions

        self.clearAll = function () {
            location.href = location.href.split("?")[0];
        };

        self.clearYear = function () {
            self.year(null);
        };

        self.clearName = function () {
            self.name(null);
        };
        self.clearLocation = function () {
            self.zipOrAddress(null);
            self.radius(null);
        };

        var clearFacetOptions = function () {
            self.nameOptions([]);
        };

        self.resetFilters = function () {
            isSystemResettingFilters = true;

            self.hasSearchRun(false);

            tempResults = [];
            self.results([]);
            self.totalResults(0);

            clearFacetOptions();
            utility.resetFiltersToDefaults(primaryFilters, defaultParameters);

            self.clearYear();
            isSystemResettingFilters = false;
        };

        self.beginSearch = function () {
            self.fatalError(false);
            if (self.isAnyRequiredFieldPopulated()) {
                self.isSearchStarted(true);
                self.results([]);
                self.totalResults(0);
                executeSearch(true);
            } else {
                self.displayRequiredFieldError(true);
            }
        };

        self.setFocusOnResults = function () {
            utility.setFocusOnResults();
        };
        self.loadPrev = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) - 1);
            utility.setFocusOnResults();
        };
        self.loadNext = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) + 1);
            utility.setFocusOnResults();
        };
        self.setPage = function (pageObject) {
            utility.setPageNumber(self, pageObject);
        };
        self.setLastPage = function () {
            self.pageNumber(parseInt(self.pages(), 10));
            utility.setFocusOnResults();
        };

        self.viewDetails = function (providerId, institutionId, lat, lng) {
            self.isLeavingForDetailPage(true);
            self.detailId(providerId);

            var query = {
                // required
                providerId: providerId,
                latitude: lat,
                longitude: lng,
                radius: self.radius(),
                year: self.year(),

                // for future use
                zipOrAddress: self.zipOrAddress(),
                name: self.name(),

                // pass through URL params
                Return_URL: returnUrl,
                path: path
            };

            query = urlParameters.reduceParams(query, {});

            window.location.href = window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        };

        self.pdfUrl = ko.computed(function () {
            var params = self.currentSearchParameters();

            if (!params) {
                return null;
            }

            var filteredParams = urlParameters.reduceParams(params, defaultParameters, false);

            if (self.isAEP()) {
                filteredParams.year = self.year();
            }

            filteredParams.contextItemId = self.contextItemId();
            filteredParams.radius = self.radius();
            filteredParams.pageNumber = self.pageNumber();
            filteredParams.pageSize = self.pageSize();

            return "/controller/SnfSearchPdf/Download?" + querystring.stringify(filteredParams);
        });

        self.emailUrl = ko.computed(function () {
            var urlParts = window.location.href.split("/");

            var domain = urlParts[0] + "//" + urlParts[2],
                downloadLink = domain + self.pdfUrl(),
                subject = encodeURIComponent("Your SCAN Search"),
                body = encodeURIComponent("Download your PDF here: " + downloadLink),
                emailUrl = "mailto:?subject=" + subject + "&body=" + body;

            return emailUrl;
        });

        function geoLocateZipcode() {
            // use current location to get results
            try {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var latitude = position.coords.latitude;
                            var longitude = position.coords.longitude;

                            // chrome dev tools allows you to set geo sensor to 33.8071979, -118.1444659 (SCAN HQ)
                            geocoder.geodecode(latitude, longitude).then(function (result) {
                                self.zipOrAddress(result.zipcode); // this kicks off a filter update
                            });
                        },
                        function () {
                            console.log("user declined geolocation");
                        }
                    );
                }
            } catch (e) {
                console.log(e.message);
            }
        }

        if (!self.zipOrAddress()) {
            geoLocateZipcode();
        } else {
            // retrieve the full set of results
            var maxPage = self.pageNumber();
            var initialPageSize = pageSize;

            if (maxPage > 1) {
                self.pageSize(maxPage * initialPageSize);
            }

            console.log("page load searching");
            self.beginSearch();
            self.pageSize(initialPageSize);
            self.pageNumber(maxPage);
        }
        initialLoad = false;
    };
});
